"use client";

import { useRef } from "react";
import { Enlace } from "@/components/Enlace";
import { CambioIdioma } from "@/components/CambioIdioma";

type Opcion = {
  href: string;
  txt: string;
  hrefLang?: string;
  lang?: string;
  className?: string;
  /** Si es true, es un título de grupo (no un enlace). */
  titulo?: boolean;
  /** El enlace al otro idioma: se calcula aquí para quedarse en la misma página. */
  cambiaIdioma?: boolean;
};

export function MenuMovil({ etiqueta, opciones }: { etiqueta: string; opciones: Opcion[] }) {
  const menu = useRef<HTMLDetailsElement>(null);
  const cerrar = () => menu.current?.removeAttribute("open");

  return (
    <details ref={menu} className="menu-movil">
      <summary>{etiqueta}</summary>
      <div className="panel">
        {opciones.map((opcion, indice) => opcion.titulo ? <p key={`t-${indice}`} className="menu-grupo">{opcion.txt}</p> : opcion.cambiaIdioma ? <CambioIdioma key="idioma" otro={opcion.lang ?? "en"} texto={opcion.txt} className={opcion.className} onClick={cerrar} /> : (
          <Enlace key={`${opcion.href}-${opcion.txt}-${indice}`} href={opcion.href} hrefLang={opcion.hrefLang} lang={opcion.lang} className={opcion.className} onClick={cerrar}>
            {opcion.txt}
          </Enlace>
        ))}
      </div>
    </details>
  );
}
